import { IAvailableRolelist } from 'models/IUserData'
import React from 'react'
import PhoneInput from 'ui/text-fields/phone-input/PhoneInput'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { UserEditField } from '../../../../../shared/UserEditField'
import SelectionField from '../../../../../shared/textFields/SelectionField'
import CreateRolePopup from '../../../../CreateRolePopup'
import {
	ErrorResponseType,
	ErrorState,
	SettingUserValidators,
	UpdateUserDataField,
	UserFormState,
} from '../../types/settingUserTypes'

type RoleContactBlockProps = {
	availableRoles: IAvailableRolelist[]
	currentUserId?: number
	userData: UserFormState
	errorState: ErrorState
	setErrorState: React.Dispatch<React.SetStateAction<ErrorState>>
	validators: SettingUserValidators
	updateUserDataField: UpdateUserDataField
	isCreateRolePopup: boolean
	setIsCreateRolePopup: React.Dispatch<React.SetStateAction<boolean>>
	changeCurrentRole: () => void
	setErrorStateMessages: React.Dispatch<React.SetStateAction<ErrorResponseType>>
	setOpenErrorPopup: React.Dispatch<React.SetStateAction<boolean>>
	serverErrorText: string
	setServerErrorText: React.Dispatch<React.SetStateAction<string>>
}

const RoleContactBlock: React.FC<RoleContactBlockProps> = ({
	availableRoles,
	currentUserId,
	userData,
	errorState,
	setErrorState,
	validators,
	updateUserDataField,
	isCreateRolePopup,
	setIsCreateRolePopup,
	changeCurrentRole,
	setErrorStateMessages,
	setOpenErrorPopup,
	serverErrorText,
	setServerErrorText,
}) => (
	<>
		<TypographyPrimary16Bold>Роль</TypographyPrimary16Bold>

		<SelectionField
			roleModel
			id={`userRole${currentUserId}`}
			choiceList={availableRoles}
			currentValue={userData.role}
			onChange={value => updateUserDataField('role', value)}
			onClick={() => setIsCreateRolePopup(true)}
			width={'100%'}
			inputLabel='Роль пользователя'
		/>

		<CreateRolePopup
			open={isCreateRolePopup}
			setIsCreateRolePopup={setIsCreateRolePopup}
			changeCurrentRole={changeCurrentRole}
			setErrorStateMessages={setErrorStateMessages}
			setOpenErrorPopup={setOpenErrorPopup}
		/>

		<TypographyPrimary16Bold>Контактная информация</TypographyPrimary16Bold>
		<UserEditField
			isErrorFocus={errorState.email}
			onBlur={() => validators.email()}
			onFocus={() => {
				setErrorState({ ...errorState, email: false })
			}}
			helperText='Укажите электронную почту'
			value={userData.email}
			width={'100%'}
			id={`useremail${currentUserId}`}
			isError={!currentUserId && !userData.email}
			label='Электронная почта'
			onChange={e => updateUserDataField('email', e.target.value)}
		/>
		<PhoneInput
			id={`telep${currentUserId}`}
			onChange={value => updateUserDataField('mobile_phone', value)}
			name={'phone'}
			value={userData.mobile_phone}
			onBlur={() => validators.phoneNum()}
			width={'100%'}
			dropDownWidth={'500px'}
			isError={Boolean(serverErrorText)}
			onFocus={() => {
				setErrorState({ ...errorState, phoneNum: false })
				setServerErrorText('')
			}}
			helperText={serverErrorText ? serverErrorText : 'Укажите номер телефона'}
			isShowHelperText={Boolean(serverErrorText) || errorState.phoneNum}
		/>
	</>
)

export default RoleContactBlock
